type SearchFilterBarProps = {
  pattern: string
  label?: string
  className?: string
}

export function SearchFilterBar({
  pattern,
  label = 'Filtered by search',
  className = ''
}: SearchFilterBarProps) {
  return (
    <div
      className={`shrink-0 border-b border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-700 ${className}`}
      title={`${label}: ${pattern}`}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">{label}</span>
        <span className="font-mono tabular-nums text-blue-600">{pattern}</span>
      </div>
    </div>
  )
}
